// Registered synchronously at script evaluation (deferred scripts all run
// before Alpine starts on DOMContentLoaded). The old requestAnimationFrame
// wrapper could fire AFTER alpine:init — the component then never
// registered and the banner never showed at all.
(() => {
  const register = () => {
    Alpine.data('xCookieBanner', (delay) => ({
      show: false,
      init() {
        // Preview override: ?dp_cookie=1 forces the banner open (no delay)
        // even after consent was already given — for design review.
        const force = new URLSearchParams(window.location.search).has('dp_cookie');

        // DP change (2026-07-28): the stock gate (userCanBeTracked() &&
        // no_interaction) only fires in consent-required regions (GDPR),
        // so US visitors never saw the banner. Show it to EVERY visitor
        // until they make a choice; the choice is remembered locally and
        // still recorded through Shopify's customerPrivacy API.
        const CHOICE_KEY = 'dp_cookie_choice';
        let chosen = null;
        try { chosen = localStorage.getItem(CHOICE_KEY); } catch (e) { /* private mode */ }
        if (chosen && !force) return;

        setTimeout(() => {
          window.Shopify.loadFeatures([
            {
              name: 'consent-tracking-api',
              version: '0.1',
            }
          ],
          (error) => {
            if (error) {
              throw error;
            }

            // An explicit prior consent recorded by Shopify (e.g. set on
            // another device-session before localStorage existed) also
            // counts as "already decided".
            const consent = window.Shopify.customerPrivacy.getTrackingConsent();
            const decided = chosen || consent === 'yes' || consent === 'no';

            if (force || !decided) {
              this.show = true;
            }

            document.dispatchEvent(new CustomEvent("eurus:customer-privacy:loaded"));
          });
        }, force ? 300 : delay * 1000);
      },
      remember(value) {
        try { localStorage.setItem('dp_cookie_choice', value); } catch (e) { /* best-effort */ }
      },
      handleAccept() {
        if (window.Shopify.customerPrivacy) {
          window.Shopify.customerPrivacy.setTrackingConsent(true, () => {});
        }
        this.remember('accept');
        requestAnimationFrame(() => {
          this.show = false;
        });
      },
      handleDecline() {
        if (window.Shopify.customerPrivacy) {
          window.Shopify.customerPrivacy.setTrackingConsent(false, () => {});
        }
        this.remember('decline');
        requestAnimationFrame(() => {
          this.show = false;
        });
      }
    }));
  };
  if (window.Alpine && window.Alpine.data) register();
  else document.addEventListener('alpine:init', register);
})();
